// @flow
import { onUpdateUserLayers } from 'catena/er2_map_userlayers/js/actions/map'
import { updateAppState } from './server_state'
import * as types from '../constants/action_types'

export const onTransimsSetZoneColor = (zone, color) => ({ type: types.TRANSIMS_ZONE_COLOR, zone, color })
export const transimsRunning = running => ({ type: types.TRANSIMS_RUNNING, running })

const waitTime = 10000
export const checkRun = suid => (dispatch, getState) => {
    let fetchError = false
    const token = getState().token.value
    fetch(`/${getState().meta.name}/api/v1/transims_check/?token=${token}`, {
        body: JSON.stringify({
            suid,
        }),
        method: 'POST',
    }).then((response) => {
        fetchError = !response.ok
        if (fetchError) {
            dispatch(transimsRunning(false))
        }
        return response.json()
    }).then((json) => {
        if (json.suid) {
            setTimeout(() => {
                dispatch(checkRun(json.suid))
            }, waitTime)
        } else if (fetchError) {
            dispatch(onUpdateUserLayers())
            alert(json.exception.message)
        } else {
            dispatch(onUpdateUserLayers())
            dispatch(transimsRunning(false))
        }
    }).catch((json) => {
        dispatch(transimsRunning(false))
    })
}
export const onTransimsRun = (transimFeatures, transimPoints) => (dispatch, getState) => {
    let fetchError = false
    dispatch(transimsRunning(true))
    const colors = getState().transims.zoneColors
    const token = getState().token.value

    dispatch(updateAppState('transims'))

    fetch(`/${getState().meta.name}/api/v1/transims/?token=${token}`, {
        body: JSON.stringify({
            colors, transimFeatures, transimPoints,
        }),
        method: 'POST',
    }).then((response) => {
        fetchError = !response.ok
        return response.json()
    }).then((json) => {
        if (fetchError) {
            alert(json.exception.message)
        } else {
            dispatch(onUpdateUserLayers())
            setTimeout(() => {
                dispatch(checkRun(json.suid))
            }, waitTime)
        }
    }).catch((json) => {
        dispatch(transimsRunning(false))
    })
}
